export const ADD_PRODUCT_ITEM = 'productItem/addProductItem';
export const DELETE_PRODUCT_ITEM = 'productItem/deleteProductItem';
export const INCREASE_PRODUCT_QUANTITY = 'productItem/increaseProductQuantity';
export const DECREASE_PRODUCT_QUANTITY = 'productItem/decreaseProductQuantity';
export const RESET_PRODUCT_QUANTITY = 'productItem/resetProductQuantity';
